module.exports = __webpack_public_path__ + "packs/media/images/close-95ba0058f5f1db57d0a4360ed1f8d7f0.svg";